import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import RegisteredUsers from './pages/Users/RegisteredUsers';
import JobManager from './pages/Jobs/JobManager';
import JobApplications from './pages/Applications/JobApplications';
import SubmissionsList from './pages/Applications/SubmissionsDetails';
import ExpertList from './pages/Experts/ExpertList';
import PosterManager from './pages/Posters/PosterManager';
import AdminLogin from './pages/AdminLogin';
import ProtectedRoute from './pages/ProdectedRoute/ProdectedRoute';
import { Logout } from './services/auth';
import Company from './pages/company/Company';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<AdminLogin />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <div className="d-flex">
                <Sidebar />
                <div className="flex-grow-1 bg-light">
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/users" element={<RegisteredUsers />} />
                    <Route path="/jobs" element={<JobManager />} />
                    <Route path="/applications" element={<JobApplications />} />
                    <Route path="/submissions" element={<SubmissionsList />} />
                    <Route path="/expertise" element={<ExpertList />} />
                    <Route path="/companies" element={<Company />} />
                    <Route path="/posters" element={<PosterManager />} />
                    <Route path="/logout" element={<Logout />} />
                  </Routes>
                </div>
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
      <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Router>
  );
};

export default App;